import { CALL_API } from '../../middleware/api';

export const LOADING_UNIVERSE = Symbol('LOADING_UNIVERSE');
export const RELOADING_UNIVERSE = Symbol('RELOADING_UNIVERSE');
export const LOADED_UNIVERSE_FAILURE = Symbol('LOADED_UNIVERSE_FAILURE');
export const RELOADED_UNIVERSE_FAILURE = Symbol('RELOADED_UNIVERSE_FAILURE');
export const LOADED_UNIVERSE_SUCCESS = Symbol('LOADED_UNIVERSE_SUCCESS');
export const RELOADED_UNIVERSE_SUCCESS = Symbol('RELOADED_UNIVERSE_SUCCESS');
export const LOADING_SORTED_UNIVERSE = Symbol('LOADING_SORTED_UNIVERSE');
export const LOADED_SORTED_UNIVERSE_FAILURE = Symbol('LOADED_SORTED_UNIVERSE_FAILURE');
export const LOADED_SORTED_UNIVERSE_SUCCESS = Symbol('LOADED_SORTED_UNIVERSE_SUCCESS');
export const SORT_UNIVERSE = Symbol('SORT_UNIVERSE');

/**
 * Load universe list.
 *
 * @param id {Number} Project's id.
 * @param queryParams {Object} - query params.
 * @param queryParams.limit {String}.
 * @param queryParams.sort {Number}.
 * @param queryParams.page {Number}.
 * @param queryParams.all {Number}.
 * @param afterSuccess {Function}.
 * @param isReload {Boolean}.
 * @returns Action.
 */
export function loadUniverse(id, queryParams, { afterSuccess } = {}, isReload = false) {
  const query = queryParams
    ? {
        sort: queryParams.sort,
        limit: queryParams.limit || 60,
        page: queryParams.page || 1,
        all: queryParams.all || 0,
      }
    : null;

  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/ceo_projects/${id}/universe`,
      query,
      startType: isReload ? RELOADING_UNIVERSE : LOADING_UNIVERSE,
      errorType: isReload ? RELOADED_UNIVERSE_FAILURE : LOADED_UNIVERSE_FAILURE,
      successType: isReload ? RELOADED_UNIVERSE_SUCCESS : LOADED_UNIVERSE_SUCCESS,
      afterSuccess,
    },
  };
}

/**
 * Load sorted universe list.
 *
 * @param id {Number} Project's id.
 * @param queryParams {Object} - query params.
 * @param queryParams.limit {String}.
 * @param queryParams.sort {Number}.
 * @param afterSuccess {Function}.
 * @returns Action.
 */
export function loadSortedUniverse(id, queryParams, { afterSuccess } = {}) {
  const query = queryParams
    ? {
        sort: queryParams.sort,
        limit: queryParams.limit || 30,
        all: queryParams.all || 0,
        page: 1,
      }
    : null;

  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/ceo_projects/${id}/universe`,
      query,
      startType: LOADING_SORTED_UNIVERSE,
      errorType: LOADED_SORTED_UNIVERSE_FAILURE,
      successType: LOADED_SORTED_UNIVERSE_SUCCESS,
      afterSuccess,
    },
  };
}

/**
 * Sort universe list.
 *
 * @param field {String} Field name.
 * @param direction {up|down} Sorting direction.
 * @returns Action.
 */
export function sortUniverse(field, direction) {
  return {
    type: SORT_UNIVERSE,
    field,
    direction,
  };
}
